<template>
  <div
    class="dnd"
    @dragenter.prevent="onEnter"
    @dragover.prevent="onOver"
    @dragleave.prevent="onLeave"
    @drop.prevent="onDrop"
  >
    <slot />
    <div class="dnd__overlay" v-if="active && !disabled">
      <div class="dnd__box">Отпустите, чтобы прикрепить файлы</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DragAndDropUploader',
  props: {
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { depth: 0 };
  },
  computed: {
    active() {
      return this.depth > 0;
    },
  },
  methods: {
    hasFiles(event) {
      const types = event.dataTransfer && event.dataTransfer.types;
      return !!types && Array.prototype.indexOf.call(types, 'Files') > -1;
    },
    onEnter(event) {
      if (!this.hasFiles(event)) return;
      this.depth += 1;
    },
    onOver(event) {
      if (this.hasFiles(event) && event.dataTransfer) {
        event.dataTransfer.dropEffect = this.disabled ? 'none' : 'copy';
      }
    },
    onLeave() {
      if (this.depth > 0) this.depth -= 1;
    },
    onDrop(event) {
      this.depth = 0;
      if (this.disabled) return;
      const list = event.dataTransfer && event.dataTransfer.files;
      if (!list || !list.length) return;
      this.$emit('add', Array.from(list));
    },
  },
};
</script>

<style scoped>
.dnd {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}

.dnd__overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 137, 172, 0.12);
  border: 2px dashed var(--accent, #0b89ac);
  border-radius: 12px;
  pointer-events: none;
}

.dnd__box {
  background: var(--surface, #fff);
  color: var(--text, #1c1e21);
  padding: 12px 18px;
  border-radius: 10px;
  font-size: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
</style>
